<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)"   size="large"   color="#0058ff"  type="ball-scale-pulse"  [fullScreen]="true">
  <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>
<div class="content-wrapper container-fluid">
    <div class="row">
        <div class="col-12 col-sm-6 col-md-3">
            <div class="card">
                <div class="card-header">
                    <h3 class="text-primary"><i class=" fas fa-house-user"> บันทึกการตรวจเยี่ยมเกษตรกร</i></h3>
                </div>
                <div class="card-body">
                    <form #userForm="ngForm" (ngSubmit)="userForm.form.valid && onSubmit(userForm)" novalidate>
                        <div class="form-group">
                            <div class="row">
                                <label >เลือกปี </label>
                                <select class="form-select"  name="year" #year="ngModel" [(ngModel)]="model.year">
                                    <option *ngFor="let item of selectyear" [ngValue]="[item.code,item.desc,item.api]">{{item.desc}}</option>
                                  </select>
                                <label>โควตาชาวไร่</label>
                                <input type="text" class="form-control" list="farmer" maxlength="10" (keypress)="numberOnly($event);" name="fmcode" #fmcode="ngModel" [(ngModel)]="model.fmcode">
                                <datalist  id="farmer" >
                                    <option  *ngFor="let item of famerlist"> 
                                        {{item.fmcode_b1}} {{item.fmname}}  
                                    </option>
            
                                </datalist>
                                <div class="invalid-feedback" *ngIf="userForm.submitted && fmcode.invalid">
                                    <small>!! กรุณารุบุโควตาชาวไร่ก่อน !!</small>
                                </div>
                                <button class="btn btn-primary" (click)="LoadOnefarmerdata();">โหลดข้อมูลแปลง</button>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <label>เลือกแปลง</label>
                                <select class="form-control" name="landno" #landno="ngModel" [(ngModel)]="model.landno"
                                    required [ngClass]="{ 'is-invalid': userForm.submitted && landno.invalid }">
                                    <option value="00" disabled>++เลือกแปลง++</option>
                                    
                                    <option *ngFor="let item of fmplantlist" [ngValue]="item.itid">{{item.fmname}} {{item.intlandno}} {{item.CaneTypeName}} {{item.landvalue}}
                                        ไร่
                                        รูท {{item.route}} โซน {{item.supzone}}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="userForm.submitted && landno.invalid">
                                    <small>กรุณาเลือกหมายเลขแปลง</small>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>กิจกรรมที่จะต้องทำ
                                <span class="badge rounded-pill bg-warning">1</span>
                            </label>
                            <select class="form-control" name="activity1" #activity1="ngModel"
                                [(ngModel)]="model.activity1" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity1.invalid }">
                                <option value="00" disabled>++เลือกกิจกรรมที่1++</option>
                              <option *ngFor="let item of listaction" [ngValue]="item.ac_id">{{item.op_desc}}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="userForm.submitted && activity1.invalid">
                                <small>กรุณาเลือกกิจกรรมที่1</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>ทำภายในวันที่</label>
                            <input type="date" name="activity1Date" class="form-control" #activity1Date="ngModel"
                                [(ngModel)]="model.activity1Date" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity1Date.invalid }">
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>กิจกรรมที่จะต้องทำ
                                <span class="badge rounded-pill bg-warning">2</span>
                            </label>
                            <select class="form-control" name="activity2" #activity2="ngModel"
                                [(ngModel)]="model.activity2" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity2.invalid }">
                                <option value="00" disabled>++เลือกกิจกรรมที่2++</option>
                              <option *ngFor="let item of listaction" [ngValue]="item.ac_id">{{item.op_desc}}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="userForm.submitted && activity2.invalid">
                                <small>กรุณาเลือกกิจกรรมที่2</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>ทำภายในวันที่</label>
                            <input type="date" name="activity2Date" class="form-control" #activity2Date="ngModel"
                                [(ngModel)]="model.activity2Date" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity2Date.invalid }">
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>กิจกรรมที่จะต้องทำ
                                <span class="badge rounded-pill bg-warning">3</span>
                            </label>
                            <select class="form-control" name="activity3" #activity3="ngModel"
                                [(ngModel)]="model.activity3" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity3.invalid }">
                                <option value="00" disabled>++เลือกกิจกรรมที่3++</option>
                                <option *ngFor="let item of listaction" [ngValue]="item.ac_id">{{item.op_desc}}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="userForm.submitted && activity3.invalid">
                                <small>กรุณาเลือกกิจกรรมที่3</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>ทำภายในวันที่</label>
                            <input type="date" name="activity3Date" class="form-control" #activity3Date="ngModel"
                                [(ngModel)]="model.activity3Date" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity3Date.invalid }">
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>กิจกรรมที่จะต้องทำ
                                <span class="badge rounded-pill bg-warning">4</span>
                            </label>
                            <select class="form-control" name="activity4" #activity4="ngModel"
                                [(ngModel)]="model.activity4" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity4.invalid }">
                                <option value="00" disabled>++เลือกกิจกรรมที่4++</option>
                              <option *ngFor="let item of listaction" [ngValue]="item.ac_id">{{item.op_desc}}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="userForm.submitted && activity4.invalid">
                                <small>กรุณาเลือกกิจกรรมที่4</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>ทำภายในวันที่</label>
                            <input type="date" name="activity4Date" class="form-control" #activity4Date="ngModel"
                                [(ngModel)]="model.activity4Date" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity4Date.invalid }">
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>กิจกรรมที่จะต้องทำ
                                <span class="badge rounded-pill bg-warning">5</span>
                            </label>
                            <select class="form-control" name="activity5" #activity5="ngModel"
                                [(ngModel)]="model.activity5" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity5.invalid }">
                                <option value="00" disabled>++เลือกกิจกรรมที่5++</option>
                                <option *ngFor="let item of listaction" [ngValue]="item.ac_id">{{item.op_desc}}</option>
                                </select>
                        </div>   
                        <div class="form-group">
                            <label>ทำภายในวันที่</label>
                            <input type="date" name="activity5Date" class="form-control" #activity5Date="ngModel"
                                [(ngModel)]="model.activity5Date" required
                                [ngClass]="{ 'is-invalid': userForm.submitted && activity5Date.invalid }">
                        </div>

                        <div class="form-group">
                           <button class="btn btn-success" type="submit">บันทึกกิจกรรม</button>
                        </div>
                    </form>
                </div> 
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-9">
            <div class="card">
                <div class="card-header">รายการที่บันทึก </div>
                <div class="card-body">
                    <table class="table" *ngIf="myenterlist != null" #table>
                        <thead>
                            <tr>
                                <td>วันที่</td>
                                <td>เลขแปลง</td>
                                <td>ชื่อ</td>
                                <td>ข้อมูลแปลง</td>
                                <td>กิจกรรม 1</td>
                                <td>วันที่ </td>
                                <td>กิจกรรม 2</td>
                                <td>วันที่</td>
                                <td>วันที่กิจกรรม 3</td>
                                <td>วันที่</td>
                                <td>กิจกรรม 4</td>
                                <td>วันที่</td>
                                <td>กิจกรรม 5</td>
                                <td>วันที่</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dt of myenterlist">
                                <td>{{dt.date_add | date}}</td>
                                <td>{{dt.intlandno}}</td>
                                <td>{{dt.fmname}}</td>
                                <td>{{dt.CaneTypeName}} {{dt.landvalue}} ไร่ {{dt.seedname}} โซน {{dt.supzone}} รูท {{dt.route}} </td>
                                <td>{{dt.operate1_desc}}</td>
                                <td>{{dt.operate_date1 | date}}</td>
                                <td>{{dt.operate2_desc}}</td>
                                <td>{{dt.operate_date2 | date}}</td>
                                <td>{{dt.operate3_desc}}</td>
                                <td>{{dt.operate_date3 | date}}</td>
                                <td>{{dt.operate4_desc}}</td>
                                <td>{{dt.operate_date4 | date}}</td>
                                <td>{{dt.operate5_desc}}</td>
                                <td>{{dt.operate_date5 | date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>                